import { useLocale } from "next-intl";
import { formatMoney } from "@/lib/utils/money";

/**
 * formatMoney bound to the page's locale, for components that render amounts
 * (Spree 6.1 drops the `display_*` strings, #263). The route locale is what
 * Spree used for those strings, so the output is unchanged.
 */
export function useFormatMoney(): (
  amount: string | null | undefined,
  currency: string | null | undefined,
) => string {
  const locale = useLocale();
  return (amount, currency) => formatMoney(amount, currency, locale);
}
